import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailListKeys"*/ './lazyIndex'),
    { name: 'MailListKeys' }
);
export const lazySetupMailListContentKeys: LazyAction<
    typeof lazyIndex.setupMailListContentKeys,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setupMailListContentKeys);

export const lazySetupMailListItemContainerKeys: LazyAction<
    typeof lazyIndex.setupMailListItemContainerKeys,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setupMailListItemContainerKeys);
